"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolume = exports.get24HoursVolume = exports.get30DaysVolume = void 0;
const anchor_1 = require("@project-serum/anchor");
const U8_MAX = new anchor_1.BN(255);
const SLOT_INTERVAL_30_DAYS = new anchor_1.BN(86400);
const SLOT_INTERVAL_24_HOURS = new anchor_1.BN(3600);
const NUM_SLOT_30_DAYS = new anchor_1.BN(30);
const NUM_SLOT_24_HOURS = new anchor_1.BN(24);
function getNumShiftTimeSlot30Days(currentTimestamp, lastTimestamp) {
    if (currentTimestamp.lt(lastTimestamp)) {
        return [new anchor_1.BN(0), new anchor_1.BN(0)];
    }
    // Saturating subtraction
    let difference = currentTimestamp.gte(lastTimestamp)
        ? currentTimestamp.sub(lastTimestamp)
        : new anchor_1.BN(0);
    let numShiftTimeSlot = difference.div(SLOT_INTERVAL_30_DAYS);
    let remaining = currentTimestamp.sub(lastTimestamp.add(SLOT_INTERVAL_30_DAYS.mul(numShiftTimeSlot)));
    if (numShiftTimeSlot.gt(U8_MAX)) {
        return [U8_MAX, remaining];
    }
    return [numShiftTimeSlot, remaining];
}
const get30DaysVolume = (kycCertData) => {
    // Get current timestamp in seconds
    const currentTimestamp = new anchor_1.BN(Math.floor(Date.now() / 1000));
    const [numShiftTimeSlot, _] = getNumShiftTimeSlot30Days(currentTimestamp, kycCertData.dayVolumesHistory.lastApplicableTime);
    if (numShiftTimeSlot.gt(NUM_SLOT_30_DAYS)) {
        return new anchor_1.BN(0);
    }
    let totalVolume = new anchor_1.BN(0);
    const tail = kycCertData.dayVolumesHistory.head;
    let head = (tail + numShiftTimeSlot.toNumber() + 1) % NUM_SLOT_30_DAYS.toNumber();
    while (head !== tail) {
        totalVolume = totalVolume.add(kycCertData.dayVolumesHistory.volumes[head]);
        head = (head + 1) % NUM_SLOT_30_DAYS.toNumber();
    }
    // Include the day at the tail index in the sum
    totalVolume = totalVolume.add(kycCertData.dayVolumesHistory.volumes[tail]);
    return totalVolume;
};
exports.get30DaysVolume = get30DaysVolume;
function getNumShiftTimeSlot24Hours(currentTimestamp, lastTimestamp) {
    if (currentTimestamp.lt(lastTimestamp)) {
        return [new anchor_1.BN(0), new anchor_1.BN(0)];
    }
    let difference = currentTimestamp.gte(lastTimestamp)
        ? currentTimestamp.sub(lastTimestamp)
        : new anchor_1.BN(0);
    let numShiftTimeSlot = difference.div(SLOT_INTERVAL_24_HOURS);
    let remaining = currentTimestamp.sub(lastTimestamp.add(SLOT_INTERVAL_24_HOURS.mul(numShiftTimeSlot)));
    if (numShiftTimeSlot.gt(U8_MAX)) {
        return [U8_MAX, remaining];
    }
    return [numShiftTimeSlot, remaining];
}
const get24HoursVolume = (kycCertData) => {
    // Get current timestamp in seconds
    const currentTimestamp = new anchor_1.BN(Math.floor(Date.now() / 1000));
    const [numShiftTimeSlot, _] = getNumShiftTimeSlot24Hours(currentTimestamp, kycCertData.hourVolumesHistory.lastApplicableTime);
    if (numShiftTimeSlot.gt(NUM_SLOT_24_HOURS)) {
        return new anchor_1.BN(0);
    }
    let totalVolume = new anchor_1.BN(0);
    const tail = kycCertData.hourVolumesHistory.head;
    let head = (tail + numShiftTimeSlot.toNumber() + 1) % NUM_SLOT_24_HOURS.toNumber();
    while (head !== tail) {
        totalVolume = totalVolume.add(kycCertData.hourVolumesHistory.volumes[head]);
        head = (head + 1) % NUM_SLOT_24_HOURS.toNumber();
    }
    // Include the day at the tail index in the sum
    totalVolume = totalVolume.add(kycCertData.hourVolumesHistory.volumes[tail]);
    return totalVolume;
};
exports.get24HoursVolume = get24HoursVolume;
const getVolume = (kycCertData) => {
    const dayVols = (0, exports.get30DaysVolume)(kycCertData);
    const hourVols = (0, exports.get24HoursVolume)(kycCertData);
    return { dayVols, hourVols };
};
exports.getVolume = getVolume;
